export const CONTACT_EMAIL = "info@prodigyincorporated.it";
export const INSIGHTS_MAILTO = `mailto:${CONTACT_EMAIL}?subject=Richiesta%20attivazione%20Insights`;

export const PLANS = [
  {
    id: "horizon",
    name: "Horizon",
    subtitle: "Esplora nuovi orizzonti",
    price: { standard: 1020, pcto: 900 },
    contacts: 15,
    contactsLabel: "15 contatti/anno",
    features: [
      "Fino a 15 contatti/anno",
      "Contatti Junior disponibili dopo 96h",
      "Grafico attitudinale",
      "Analisi AI integrata per i profili Junior",
      "Sconto ospitalità di € 120 per disponibilità 1 volta/anno",
    ],
    insights: ["Test attitudinale dei dipendenti", "Prodigy Pulse mensile", "Mismatch Radar (Allineamento)"],
  },
  {
    id: "vision",
    name: "Vision",
    subtitle: "Oltre l'apparenza",
    price: { standard: 3600, pcto: 3060 },
    contacts: 100,
    contactsLabel: "100 contatti/anno (50 Junior + 50 Senior)",
    featured: true,
    badges: ["Consigliato"],
    features: [
      "Fino a 50 contatti Junior all'anno",
      "Profili Junior disponibili dopo 48h",
      "Analisi AI integrata per i profili Junior",
      "Assistente AI integrato nella dashboard Junior",
      "Grafico attitudinale dei profili Junior",
      "Sconto ospitalità di € 540 per disponibilità FSL (ex PCTO) fino a 3 volte/anno",
      "Accesso completo ai profili Senior disponibili dopo 12h",
      "Fino a 50 contatti Senior all'anno inclusi (Analisi AI integrata, grafico attitudinale e CV)",
    ],
    insights: ["Test attitudinale dei dipendenti", "Prodigy Pulse con lettura AI di Argos", "Mismatch Radar (Allineamento)", "Scacchiera dell'Ecosistema", "Report PDF per la direzione"],
  },
  {
    id: "omega",
    name: "Omega",
    subtitle: "Dove il cerchio si chiude",
    price: { standard: 6000, pcto: 5100 },
    contacts: 120,
    contactsLabel: "120 contatti/anno",
    featured: true,
    badges: ["Il più completo"],
    features: [
      "Fino a 120 contatti/anno",
      "Disponibilità dei profili Junior dopo 12h",
      "Analisi AI integrata per profili Junior",
      "Grafico attitudinale profili Junior",
      "Assistente AI integrato nella sezione Junior",
      "Automated Solutions",
      "Attestato Social Impact rilasciato da Prodigy Incorporated",
      "Sconto ospitalità di € 900 per disponibilità FSL (ex PCTO) fino a 6 volte/anno",
      "Accesso completo ai profili Senior",
      "Disponibilità immediata dei profili Senior",
      "Fino a 120 contatti Senior all'anno",
      "Assistente AI integrato nella sezione Senior",
      'Funzione "Corporate Atlas" - mappa il potenziale della tua azienda',
    ],
    insights: ["Prodigy Pulse con lettura AI di Argos", "Mismatch Radar (Allineamento)", "Scacchiera dell'Ecosistema", "Turnover Radar con Confronto riservato", "Report PDF per la direzione"],
  },
  {
    id: "insights",
    name: "Insights",
    subtitle: "Ascolta la tua organizzazione",
    kind: "insights",
    insightsPrice: { monthly: 150, yearly: 1800 },
    badges: ["BETA", "Su richiesta"],
    pitch: "Non stai assumendo? Inizia ad ascoltare chi hai già.",
    features: [
      "Tutta la suite Prodigy Insights, senza limiti di dipendenti",
      "Test attitudinale dei dipendenti",
      "Prodigy Pulse mensile con lettura AI di Argos",
      "Mismatch Radar (Allineamento)",
      "Scacchiera dell'Ecosistema con scenari salvati e slot vuoti consigliati da Argos",
      "Turnover Radar con alert anonimi di reparto e Confronto riservato",
      "Report PDF per la direzione",
      "Passa a Horizon, Vision o Omega in qualsiasi momento per aggiungere il recruiting",
    ],
    note: "Versione Beta a solo scopo dimostrativo, senza valenza scientifica. I dati dei dipendenti restano anonimi.",
  },
];

export const PROMO_TEXT =
  "Le prime 6 aziende che aderiscono entrano gratis, su qualsiasi pacchetto. Raggiunte le 6 adesioni, i pacchetti tornano a pagamento.";
